import Vue from '../lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '../lib/utils/vue3compat/vue_apollo.js?vue3';
import createDefaultClient from '../lib/graphql.js?vue3';
import axios from '../lib/utils/axios_utils.js?vue3';

Vue.use(VueApollo);

const typePolicies = {
  Project: {
    fields: {
      userPermissions: {
        merge: true,
      },
    },
  },
};

// The server omits `html` when the blob has no rich viewer, but the query selects it.
export const fetchReadme = (url) =>
  axios
    .get(url, { params: { format: 'json', viewer: 'rich' } })
    .then(({ data }) => ({ html: null, ...data, __typename: 'ReadmeFile' }));

const defaultClient = createDefaultClient(
  {
    Query: {
      readme(_, { url }) {
        return fetchReadme(url);
      },
    },
  },
  {
    cacheConfig: {
      typePolicies,
      dataIdFromObject: (obj) => {
        /* eslint-disable @gitlab/require-i18n-strings */
        // eslint-disable-next-line no-underscore-dangle
        switch (obj.__typename) {
          // We need to create a dynamic ID for each entry
          // Each entry can have the same ID as the ID is a commit ID
          // So we create a unique cache ID with the path and the ID
          case 'TreeEntry':
          case 'Submodule':
          case 'Blob':
            return `${encodeURIComponent(obj.flatPath)}-${obj.id}`;
          default:
            // If the type doesn't match any of the above we fallback
            // to using the default Apollo ID
            // eslint-disable-next-line no-underscore-dangle
            return obj.id || obj._id;
        }
        /* eslint-enable @gitlab/require-i18n-strings */
      },
    },
  },
);

export default new VueApollo({
  defaultClient,
});
